import React from 'react'

const SideBySide = ({ content }) => {
    return (
        <div className="container">
            <div className="content-band side-by-side">
                <div className="text-block">
                    <p>
                        This is the left side of a side by side text block. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec odio in felis vehicula ultricies.
                        Donec in purus nec erat ultricies ultrices. Nullam nec sapien vitae purus aliquam condimentum.
                    </p>
                </div>
                <div className="text-block">
                    <p>
                        This is the right side of a side by side text block. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec odio in felis vehicula ultricies.
                        Donec in purus nec erat ultricies ultrices. Nullam nec sapien vitae purus aliquam condimentum.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SideBySide
